import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickActionsToolbar = ({ onCreateAudit, onExportReports, onViewQuestionBanks }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex flex-wrap items-center gap-3">
        <button
          onClick={onCreateAudit}
          className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors font-medium"
        >
          <Icon name="Plus" size={18} />
          Create New Audit
        </button>
        
        <button
          onClick={onViewQuestionBanks}
          className="inline-flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors font-medium"
        >
          <Icon name="Library" size={18} />
          Question Banks
        </button>

        <button
          onClick={onExportReports}
          className="inline-flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors font-medium"
        >
          <Icon name="Download" size={18} />
          Export Reports
        </button>

        <div className="ml-auto flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Info" size={16} />
          <span>Quick Actions</span>
        </div>
      </div>
    </div>
  );
};

export default QuickActionsToolbar;